import Marquee from "react-fast-marquee";

const ITEMS = [
  "TECHNO STAMPING",
  "PRECISION ENGINEERING",
  "SHEET METAL MASTERS",
  "STAMPING & PRESSING",
  "CNC MACHINING",
  "R&D EXPERTS",
];

export default function MarqueeStrip() {
  return (
    <section data-testid="marquee-section" className="py-16 lg:py-24 border-t border-border bg-primary overflow-hidden">
      <Marquee speed={60} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-semibold text-5xl lg:text-8xl text-primary-foreground px-8 tracking-tight">
              {t}
            </span>
            <span className="h-3 w-3 rounded-full bg-primary-foreground/70 mx-4" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
